import styled from 'styled-components'

import { ImgProps } from './types'

export default styled.img<ImgProps>`
  opacity: ${(props: ImgProps): number => props.isLoading ? 0.5 : 1};
  filter: ${(props: ImgProps): string | undefined => props.isLoading ? 'blur(10px)' : undefined};
  transition: all 0.5s linear;
`
